import {
  createBusinessVerifier,
  deleteBusinessVerifier,
  updateBusinessVerifier,
} from '@store/business/BusinessVerifierReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const BusinessVerifierForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const { error } = useAppSelector((state) => state.businessVerifier)
    const dispatch = useAppDispatch()

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
          update: Update,
          delete: Delete,
        }}
        handlers={{
          create: async (values) =>
            dispatch(createBusinessVerifier(values)).then(() => {
              return true
            }),
          update: async (values) =>
            dispatch(updateBusinessVerifier(values)).then(() => {
              return true
            }),
          delete: async (values) =>
            dispatch(deleteBusinessVerifier(values)).then(() => {
              return true
            }),
        }}
      />
    )
  }
)

BusinessVerifierForm.displayName = 'BusinessVerifierForm'

export default BusinessVerifierForm
